import { sessionState } from './session-state';
import { Injectable, EventEmitter } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { Router } from "@angular/router";
import * as global_var from "../global.variable";
import { NgxSpinnerService } from "ngx-spinner";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  public eventEmitter = new EventEmitter();
  public mfaEmitter = new EventEmitter();
  constructor(
    private http: HttpClient,
    private router: Router,
    private ngxSpinnerService: NgxSpinnerService,
  ) {}

  loginValidation(data: any) {
    return this.http.post("" + "login", data).pipe(
      map((res: any) => {
        return res;
      }),
    );
  }
  deleteCookie() {
    sessionState.clear();
  }
  logout() {
    this.ngxSpinnerService.show();
    return this.http.post(global_var.apiUrl + "logout", {}).pipe(
      map((res: any) => {
        this.ngxSpinnerService.hide();
        this.deleteCookie();
        sessionState.clear();
        this.router.navigate(["/login"]);
        return;
      }),
    );
  }
  logoutAsClient(data: any) {
    this.ngxSpinnerService.show();
    return this.http.post(global_var.apiUrl + "logoutasclient", data).pipe(
      map((res: any) => {
        sessionState.setItem("lac", "0");
        this.router.navigate(["/system-admin"]);
        return;
      }),
    );
  }

  showReloginPopup() {
    this.eventEmitter.emit();
  }

  showMfaPopup() {
    this.mfaEmitter.emit();
  }

  relogin(data: any) {
    return this.http.post(global_var.apiUrl + "relogin", data).pipe(
      map((res: any) => {
        return res;
      }),
    );
  }

  returnUserId() {
    return sessionState.getItem("user_id");
  }

  returnToken() {
    return sessionState.getItem("id_token");
  }

  getCookie(name: string): string | null {
    return sessionState.getItem(name);
  }

  isLoggedIn() {
    return !!(this.getCookie("access_token") && this.getCookie("id_token") &&
      this.getCookie("user_id"));
  }


  isValidUser(user_id: any) {
    return this.http
      .post(global_var.apiUrl + "checkSession", { check: 1 })
      .pipe(
        map((res: any) => {
          return res;
        }),
      );
  }

  // System Admin Settings
  settingsAPI(type, formData: any = null) {
    const api_url = "global-settings";
    return this.http.post(global_var.apiUrl + api_url, formData).pipe(
      map((res: any) => {
        return res;
      }),
    );
  }
  /* Get the current user daetails */
  getCurrentUser() {
    return this.http.post(global_var.apiUrl + "getCurrentUser", {}).pipe(
      map((res: any) => {
        return res;
      }),
    );
  }

  redirectToCustomerAccountVersion(data){
    return this.http.post(global_var.apiUrl + "auth/redirectSysAdmin", data).pipe(
      map((res: any) => {
        return res;
      }),
    );
  }

}
